export const GET_TEAMS_WATCHER = "app/WidgetResultByTeam/GET_TEAMS_WATCHER"
export const GET_TEAMS_SUCCESS = "app/WidgetResultByTeam/GET_TEAMS_SUCCESS"
export const GET_TEAMS_FAILED = "app/WidgetResultByTeam/GET_TEAMS_FAILED"
